import React from 'react';
import { Mail, Instagram, Facebook, Send } from 'lucide-react';
import { Link } from 'react-router-dom';

export const Footer = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="kontakt" style={{
      background: 'var(--brand-dark)',
      color: 'white',
      padding: 'var(--spacing-giant) 0 var(--spacing-large)'
    }}>
      <div className="container">
        {/* CTA Section */}
        <div style={{
          textAlign: 'center',
          marginBottom: 'var(--spacing-xl)',
          padding: 'var(--spacing-xl) 0'
        }}>
          <h2 className="display-medium" style={{ color: 'white', marginBottom: 'var(--spacing-medium)' }}>
            Bereit für deinen Haltung-Reset?
          </h2>
          <p className="body-large" style={{ color: 'rgba(255, 255, 255, 0.9)', marginBottom: 'var(--spacing-large)', maxWidth: '600px', margin: '0 auto var(--spacing-large)' }}>
            Starte jetzt deine Reise zu einem schmerzfreien, starken Körper.
          </p>
          <button className="btn-cta" onClick={() => scrollToSection('tarife')}>
            Jetzt starten
          </button>
        </div>

        {/* Contact & Links */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: 'var(--spacing-xl)',
          paddingTop: 'var(--spacing-xl)',
          borderTop: '1px solid rgba(255, 255, 255, 0.2)',
          marginBottom: 'var(--spacing-large)'
        }}>
          {/* Brand */}
          <div>
            <h3 style={{ fontSize: '1.5rem', fontWeight: 600, marginBottom: 'var(--spacing-medium)' }}>
              Gross Coaching
            </h3>
            <p style={{ fontSize: '1rem', lineHeight: 1.6, color: 'rgba(255, 255, 255, 0.8)' }}>
              Experte für funktionelles Training und Physiotherapie mit über 13 Jahren Erfahrung.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 style={{ fontSize: '1.125rem', fontWeight: 600, marginBottom: 'var(--spacing-medium)' }}>
              Quick Links
            </h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--spacing-small)' }}>
              <a onClick={() => scrollToSection('programm')} style={{
                color: 'rgba(255, 255, 255, 0.8)',
                textDecoration: 'none',
                cursor: 'pointer',
                transition: 'color 0.2s ease'
              }}>Programm</a>
              <a onClick={() => scrollToSection('tarife')} style={{
                color: 'rgba(255, 255, 255, 0.8)',
                textDecoration: 'none',
                cursor: 'pointer',
                transition: 'color 0.2s ease'
              }}>Tarife</a>
              <a onClick={() => scrollToSection('uber-alex')} style={{
                color: 'rgba(255, 255, 255, 0.8)',
                textDecoration: 'none',
                cursor: 'pointer',
                transition: 'color 0.2s ease'
              }}>Über Alex</a>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 style={{ fontSize: '1.125rem', fontWeight: 600, marginBottom: 'var(--spacing-medium)' }}>
              Kontakt
            </h4>
            <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--spacing-small)', marginBottom: 'var(--spacing-medium)' }}>
              <Mail size={20} />
              <a href="mailto:grossfit@web.de" style={{
                color: 'rgba(255, 255, 255, 0.8)',
                textDecoration: 'none'
              }}>
                grossfit@web.de
              </a>
            </div>
            <div style={{ display: 'flex', gap: 'var(--spacing-small)' }}>
              <a href="https://www.instagram.com/alexander.gross" target="_blank" rel="noopener noreferrer" style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '40px',
                height: '40px',
                background: 'rgba(255, 255, 255, 0.1)',
                borderRadius: '50%',
                transition: 'background 0.2s ease'
              }}>
                <Instagram size={20} />
              </a>
              <a href="https://www.facebook.com/share/1X9NKe2ubA/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '40px',
                height: '40px',
                background: 'rgba(255, 255, 255, 0.1)',
                borderRadius: '50%',
                transition: 'background 0.2s ease'
              }}>
                <Facebook size={20} />
              </a>
              <a href="https://t.me/haltungreset" target="_blank" rel="noopener noreferrer" style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '40px',
                height: '40px',
                background: 'rgba(255, 255, 255, 0.1)',
                borderRadius: '50%',
                transition: 'background 0.2s ease'
              }}>
                <Send size={20} />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div style={{
          paddingTop: 'var(--spacing-large)',
          borderTop: '1px solid rgba(255, 255, 255, 0.2)',
          display: 'flex',
          flexDirection: 'column',
          gap: 'var(--spacing-small)',
          alignItems: 'center',
          textAlign: 'center'
        }}>
          <div style={{ fontSize: '0.875rem', color: 'rgba(255, 255, 255, 0.6)' }}>
            © {new Date().getFullYear()} Gross Coaching. Alle Rechte vorbehalten.
          </div>
          <div style={{ display: 'flex', gap: 'var(--spacing-medium)', fontSize: '0.875rem', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Link to="/impressum" style={{ color: 'rgba(255, 255, 255, 0.6)', textDecoration: 'none' }}>Impressum</Link>
            <Link to="/datenschutz" style={{ color: 'rgba(255, 255, 255, 0.6)', textDecoration: 'none' }}>Datenschutz</Link>
            <Link to="/agb" style={{ color: 'rgba(255, 255, 255, 0.6)', textDecoration: 'none' }}>AGB</Link>
            <Link to="/widerruf" style={{ color: 'rgba(255, 255, 255, 0.6)', textDecoration: 'none' }}>Widerruf</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};